export function DrawerStack($compile: angular.ICompileService, $animate) {

    let drawerStack: any = {}
    let backdropDomEl;
    let containerDomEl;

    drawerStack.open = function (drawer) {
        // 创建背景层
        backdropDomEl = angular.element('<div drawer-window id="drawerBackdrop"></div>');
        backdropDomEl.attr({
            'class': 'drawer-backdrop'
        })
        $compile(backdropDomEl)(drawer.scope);

        drawerStack.close = function () {
            drawer.scope.$apply(function () {
                $animate.leave(backdropDomEl);
                $animate.leave(containerDomEl);
            })
        }

        drawer.scope.closeDrawer = drawerStack.close;

        // 添加背景层
        $animate.enter(backdropDomEl, drawer.appendTo);
        // 创建导航容器层
        containerDomEl = angular.element('<nav></nav>');
        let closeDomEl = angular.element('<div><button class="drawer-close-btn" ng-click="closeDrawer()">X</button></div>');
        closeDomEl.attr({
            'class': "drawer-header"
        })
        containerDomEl.append(closeDomEl);

        containerDomEl.attr({
            'class': "drawer-container",
            'id': "drawerContainer"
        }).append(drawer.content);

        $animate.enter($compile(containerDomEl)(drawer.scope), drawer.appendTo);
    }

    drawerStack.close = function () {
        drawer.scope.$apply(function () {
            $animate.leave(backdropDomEl);
            $animate.leave(containerDomEl);
        })
    }

    return drawerStack;
}

DrawerStack.$inject = ["$compile", "$animate"];
